﻿{
  "createAccount": "Criar conta",
  "subscription": "Assinatura",
  "oneTimePurchase": "Compra Única",
  "billingDetails": "Detalhes de faturamento",
  "paymentDetails": "Informações de pagamento",
  "requestAQuote": "Formulário de solicitação da instituição",
  "reviewOrder": "Analisar pedido",
  "thankYouForYourOrder": "Agradecemos o seu pedido!",
  "joinTheCommunity": "Participar da Comunidade",
  "startTrial": "Iniciar versão de teste",
  "yourTrialHasEnded": "Seu teste terminou",
  "taxExempt": "Isento de impostos",
  "taxExemptThankYou": "Upload realizado com sucesso!",
  "planDetails": "Detalhes da Minha Assinatura",
  "modifyPlan": "Alterar plano",
  "modifyPaymentDetails": "Alterar informações de pagamento",
  "redirect": "Redirecionando para o Boardmaker",
  "perpetualTrial": "Baixe seu teste grátis de {{trialLength}} dias",
  "perpetualThankYou": "Seu software está pronto!",
  "downloads": "Baixar Boardmaker",
  "partner": "Localizar um parceiro",
  "intro": "Selecione um produto Boardmaker abaixo para baixar a versão mais recente para o seu dispositivo.",
"systemRequirements": "Requisitos do Sistema",
"releaseNotes": "Notas de Lançamento",
"comparison": "Compare a Assinatura e a Licença"
}
